/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_CellarInputs */

const cs_form_has_cellar = /** @type {(inputs: Form_Has_CellarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklep`)
};

const en_form_has_cellar = /** @type {(inputs: Form_Has_CellarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cellar`)
};

/**
* | output |
* | --- |
* | "Cellar" |
*
* @param {Form_Has_CellarInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_cellar = /** @type {((inputs?: Form_Has_CellarInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_CellarInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_cellar(inputs)
	return cs_form_has_cellar(inputs)
});